export default __webpack_public_path__ + "static/media/roles-permission.c9d5e59b.svg";